 <ng-container *transloco="let t;">
    <div class="slideout-content">
        <!-- Modal to add attachments starts-->
        <div class="modalsd modal-slide-in sdfade playbook-right-bar" id="modals-slide-in">
            <div class="modal-dialog">
                <form class="playbook-modal modal-content pt-0">
                    <div class="modal-header mb-1 d-flex justify-content-between align-items-center px-2 py-1">
                        <div class="d-flex justify-content-start align-items-center">
                            <h5 class="modal-title" id="exampleModalLabel"> {{t('Add new playbook sidebar title (add playbook side bar) - Add playbook')}}  </h5>
                        </div>
                        <div class="d-flex justify-content-end align-items-center text-dark cursor-pointer">
                        <span placement="auto" container="body" [autoClose]="true" triggers="hover" [ngbTooltip]='t("Close tooltip (close modal button tooltip) - Close")' (click)="closeSiderBar()">
                            <i data-feather="x" [size]="16" data-dismiss="modal" aria-label="Close"></i>
                        </span>
                        </div>

                    </div>
                    <div class="modal-body flex-grow-1 p-0">
                        <ul ngbNav #navJustified="ngbNav" class="nav-tabs nav-justified playbook-right-barTabs" >
                            <li  [ngbNavItem]="LegalHubTabs.SETTINGS" destroyOnHide="false" [ngClass]="{'invalid': isSettingsTabInvalid && submitted}">
                                <a ngbNavLink>{{t("Settings tab title (Legal Hub right bar) - Settings")}}</a>
                                <ng-template ngbNavContent>
                                    <app-legal-hub-settings-tab [ngClass]="{'invalid': isSettingsTabInvalid}" [submitted]="submitted" (submitClicked)="onSubmit()" [formGroup] = "playbookForm"></app-legal-hub-settings-tab>
                                </ng-template>
                            </li>
                            <li [ngbNavItem]="LegalHubTabs.GUIDELINES" destroyOnHide="false" [ngClass]="{'invalid': isGuidelinesTabInvalid && submitted}">
                                <a ngbNavLink>{{t("Guidelines tab title (Legal Hub right bar) - Guidelines")}}</a>
                                <ng-template ngbNavContent>
                                    <app-legal-hub-guidelines-tab [submitted]="submitted" (submitClicked)="onSubmit()" [formGroup] = "playbookForm"></app-legal-hub-guidelines-tab>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="navJustified" class="mt-2"></div>
                    </div>
                </form>
            </div>
        </div>
    </div>
